// src/.../BookHeaderInfo.jsx
import React from "react";
import { Link } from "react-router-dom";
import { buildAuthorPath, buildPublisherPath, slugifyTR } from "../../../../utils/slugify";

const BookHeaderInfo = ({ meta }) => {
  if (!meta) return null;

  const {
    bookTitle,
    authors = [],
    editorsTr,          // [{mysqlId, name, surname}]
    editors = [],             // string (opsiyonel)
    publishers = [],       // [{id, name}]
    publishDate,           // "YYYY" ya da tarih
    isbn,
    eIsbn,
    doi,
    volume,
    pageCount,
    editionInfo,           // "Baskı Bilgisi"
    seriesTitle,           // "Dizi Adı"
    accessType,            // "Açık/Kapalı/Karma" (opsiyonel)
    databases = [],
    webAddress,
    translator,
    journalTitle,
    journalId,
    publicationType,
  } = meta;

  console.log(translator);

  const formatYear = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.toString().substring(0, 4);
  };


  return (
    <>

      {journalTitle && journalId && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Yayınlandığı Eser:
          </span>
          <span className="text-fume">
            <Link
              to={`/publication-details/${journalId}`}
              style={{ textDecoration: "none", color: "#392C7D" }}
            >
              {journalTitle}
            </Link>
          </span>
        </div>
      )}

      {!!authors.length && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Yazar(lar):
          </span>
          <span className="text-fume">
            {authors.map((a, i) => (
              <React.Fragment key={a.mysqlId || `${a.name}-${a.surname}-${i}`}>
                {a.mysqlId ? (
                  <Link
                    to={buildAuthorPath({ name: a.name, surname: a.surname, id: a.mysqlId })}
                    style={{ textDecoration: "none", color: "#392C7D" }}
                  >
                    {a.name} {a.surname}
                  </Link>
                ) : (
                  <span>{a.name} {a.surname}</span>
                )}
                {i < authors.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {editors.length > 0 && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold me-2 text-darkfume" style={{ minWidth: 110 }}> Editör(ler):</span>
          <span className="text-fume">
            {editors.map((a, i) => (
              <React.Fragment key={a.mysqlId || `${a.name}-${a.surname}-${i}`}>
                {a.mysqlId ? (
                  <Link
                    to={buildAuthorPath({ name: a.name, surname: a.surname, id: a.mysqlId })}
                    style={{ textDecoration: "none", color: "#392C7D" }}
                  >
                    {a.name} {a.surname}
                  </Link>
                ) : (
                  <span>{a.name} {a.surname}</span>
                )}
                {i < editors.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {translator.length > 0 && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold me-2 text-darkfume" style={{ minWidth: 110 }}> Çeviren(ler)</span>
          <span className="text-fume">
            {translator.map((a, i) => (
              <React.Fragment key={a.mysqlId || `${a.name}-${a.surname}-${i}`}>
                {a.mysqlId ? (
                  <Link
                    to={buildAuthorPath({ name: a.name, surname: a.surname, id: a.mysqlId })}
                    style={{ textDecoration: "none", color: "#392C7D" }}
                  >
                    {a.name} {a.surname}
                  </Link>
                ) : (
                  <span>{a.name} {a.surname}</span>
                )}
                {i < translator.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {!!publishers.length && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Yayıncı:
          </span>
          <span className="text-fume">
            {publishers.map((p, i) => (
              <React.Fragment key={p.id || i}>
                <Link
                  to={buildPublisherPath({ title: p.name, id: p.id || "" })}
                  style={{ textDecoration: "none", color: "#392C7D" }}
                >
                  {p.shortName && p.shortName.trim() ? p.shortName : p.name}
                </Link>
                {i < publishers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {publishDate && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Yayın Tarihi:
          </span>
          <span className="text-fume">{formatYear(publishDate)}</span>
        </div>
      )}

      {volume &&
        (
          <div className="mb-1 d-flex align-items-center">
            <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
              Cilt:
            </span>
            <span className="text-fume">{formatYear(volume)}. Cilt</span>
          </div>
        )}

      {isbn && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            ISBN:
          </span>
          <span className="text-fume">
            {Array.isArray(isbn) ? isbn.join(", ") : isbn}
          </span>
        </div>
      )}

      {eIsbn && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            e-ISBN:
          </span>
          <span className="text-fume">
            {/* Eğer eIsbn dizi (array) ise ", " ile birleştir, değilse direkt yazdır */}
            {Array.isArray(eIsbn) ? eIsbn.join(", ") : eIsbn}
          </span>
        </div>
      )}

      {/* {pageCount && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Sayfa Sayısı:
          </span>
          <span className="text-fume">{pageCount}</span>
        </div>
      )} */}

      {editionInfo && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Baskı Bilgisi:
          </span>
          <span className="text-fume">{editionInfo}</span>
        </div>
      )}

      {seriesTitle && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Dizi:
          </span>
          <span className="text-fume">{seriesTitle}</span>
        </div>
      )}

      {Array.isArray(databases) && databases.length > 0 && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Veritabanı:
          </span>
          <span className="text-fume">
            {(() => {
              const uniqueDbs = databases.map(db => {
                const name = (typeof db === "string" ? db : (db.name || db.title || ""));
                if (name.toLowerCase().includes("akademik dergiler") || name.toLowerCase().includes("popüler dergiler")) {
                  return { name: "İdealonline süreli yayınlar", path: "/journal-list/all" };
                }
                return { name, path: `/database/${slugifyTR(name)}` };
              }).filter((v, i, a) => v.name && a.findIndex(x => x.name === v.name) === i);

              return uniqueDbs.map((db, idx) => (
                <React.Fragment key={db.name}>
                  <Link to={db.path} className="text-blue" style={{ textDecoration: "none" }}>
                    {db.name}
                  </Link>
                  {idx < uniqueDbs.length - 1 && ", "}
                </React.Fragment>
              ));
            })()}
          </span>
        </div>
      )}

      {webAddress && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Web Adresi:
          </span>
          <a
            href={webAddress}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue"
            style={{ textDecoration: "none" }}
            onMouseOver={(e) => (e.currentTarget.style.textDecoration = "underline")}
            onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
          >
            {webAddress}
          </a>
        </div>
      )}

      {/* {accessType && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>
            Erişim Türü:
          </span>
          <span className="text-fume">{accessType}</span>
        </div>
      )} */}
    </>
  );
};

export default BookHeaderInfo;
